/* Additive mobile navigation to the existing offer; never submits a cart form. */
(function () {
  'use strict';

  function formatPrice(value) {
    if (!Number.isFinite(value) || value < 0) return '';
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00a0Ft';
  }

  function parsePrice(text) {
    // Require a currency label: tier counts and crossed-out prices are not prices.
    var match = String(text || '').match(/(?:^|[^\d.,])(\d+(?:[.,\s\u00a0\u202f]\d{3})*)(?:[,.]00)?\s*Ft\b/i);
    return match ? Number(match[1].replace(/\D/g, '')) : null;
  }

  function deriveBundle(single, secondUnit, secondTotal) {
    var price = parsePrice(single);
    var unit = parsePrice(secondUnit);
    var total = unit !== null ? unit * 2 : parsePrice(secondTotal);
    var saving = price !== null && total !== null ? price * 2 - total : null;
    return {
      price: formatPrice(price),
      offer: saving > 0 && saving <= price * 2 ? '2 db-tól −' + formatPrice(saving) : 'Csomagajánlat',
      ready: price !== null && total !== null
    };
  }

  function deriveStack(priceCents, discountCents) {
    return {
      price: formatPrice(Number.isFinite(priceCents) ? priceCents / 100 : null),
      offer: Number.isFinite(discountCents) && discountCents > 0 ? '2\u00a0db\u00a0−' + formatPrice(discountCents / 100) : 'Csomagajánlat'
    };
  }

  function finalHeaderBottom(headers) {
    return headers.reduce(function (bottom, header) {
      return Math.max(bottom, header.height > 0 ? Math.max(0, header.top || 0) + header.height : 0);
    }, 0);
  }

  function scrollTarget(scrollY, offerTop, headerHeight) {
    return Math.max(0, scrollY + offerTop - headerHeight - 12);
  }

  function stackDelayRemaining(active, wasActive, deadline, now) {
    if (active) return 320;
    return wasActive ? 320 : Math.max(0, deadline - now);
  }

  function stackOfferUsed(wasUsed, active, records, html) {
    return wasUsed || active || records.some(function (record) {
      return record.attributeName === 'class' &&
        ((record.target.matches('.velora-stack-bar') && /(?:^|\s)is-on(?:\s|$)/.test(record.oldValue || '')) ||
        (record.target === html && /(?:^|\s)velora-stack-bar-on(?:\s|$)/.test(record.oldValue || '')));
    });
  }

  function offerNeedsBar(state, wasNeeded) {
    var limit = state.viewportHeight - (state.barHeight + 8);
    var row = state.firstRow;
    if (row && row.width > 0 && row.height > 0 && Number.isFinite(row.bottom)) {
      return row.bottom > limit + (wasNeeded === false ? 24 : 0);
    }
    // JS-built rows may not exist or have measurable geometry yet.
    return Number.isFinite(state.buttonTop) && state.buttonTop >= limit;
  }

  function shouldShow(state, wasNeeded) {
    return !!(state.mobile && state.ready && state.hasButton && !state.blocked &&
      offerNeedsBar(state, wasNeeded));
  }

  // Keep the calculations directly testable without creating browser globals.
  if (typeof module === 'object' && module.exports) {
    module.exports = { formatPrice: formatPrice, parsePrice: parsePrice, deriveBundle: deriveBundle, deriveStack: deriveStack,
      shouldShow: shouldShow, offerNeedsBar: offerNeedsBar, finalHeaderBottom: finalHeaderBottom, scrollTarget: scrollTarget,
      stackDelayRemaining: stackDelayRemaining, stackOfferUsed: stackOfferUsed };
    return;
  }

  var script = document.currentScript;
  var cssUrl = script && script.getAttribute('data-css-url');
  var ROOT = '.velora-bundle, [data-velora-stack]';
  var BLOCKERS = '.vcb[data-vcb-open], dialog[open], [data-vsp-dialog][open], ' +
    'cart-drawer.active, cart-drawer[open], cart-drawer[aria-hidden="false"], ' +
    '#cart-notification.active, cart-notification.active, ' +
    'header-drawer details[open], details.menu-drawer-container[open], .menu-drawer-container details[open], ' +
    '.section-header details-modal details[open], sticky-header details-modal details[open], ' +
    'body.overflow-hidden, body.overflow-hidden-tablet, body.overflow-hidden-mobile';
  var STACK_BLOCKERS = '.velora-stack-bar.is-on, html.velora-stack-bar-on';
  var controller = null;
  // Page-view memory survives product-section replacement and mobile remounts.
  var stackUsed = false;

  function boot() {
    // No stylesheet, markup, observers or global flags on unrelated pages.
    if (!document.querySelector(ROOT) || window.__veloraOfferBarLoaded) return;
    window.__veloraOfferBarLoaded = true;
    var mobile = window.matchMedia('(max-width: 749px)');

    function scan() {
      var root = document.querySelector(ROOT);
      if (controller && (!mobile.matches || controller.root !== root || !root || root.hidden)) {
        controller.destroy();
        controller = null;
      }
      if (mobile.matches && root && !root.hidden && !controller) controller = mount(root, scan);
      if (controller) controller.queue();
    }

    mobile.addEventListener('change', scan);
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:unload', function (event) {
      if (controller && event.target.contains(controller.root)) {
        controller.destroy();
        controller = null;
      }
    });
    window.addEventListener('pagehide', function () {
      if (controller) controller.destroy();
      controller = null;
    });
    window.addEventListener('pageshow', scan);
    scan();
  }

  function mount(root, rescan) {
    var bundle = root.matches('.velora-bundle');
    var scope = root.closest('.product__info-container') || root.closest('.shopify-section') || document;
    var bar = document.createElement('div');
    bar.className = bundle ? 'vob' : 'vob vob--stack';
    bar.hidden = true;
    bar.inert = true;
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="vob__info"><span class="vob__price"></span><span class="vob__offer"></span></div>' +
      '<button class="vob__button" type="button"><span>Válassz ajánlatot</span>' +
      '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M8 2v12m-5-5 5 5 5-5" stroke="currentColor" stroke-width="1.5"/></svg></button>';
    document.body.appendChild(bar);
    var priceEl = bar.querySelector('.vob__price');
    var offerEl = bar.querySelector('.vob__offer');
    var button = bar.querySelector('button');
    var frame = 0;
    var alive = true;
    var shown = false;
    var offerNeeded = true;
    var cssReady = false;
    var height = 0;
    var buy = null;
    var tierWatch = null;
    var totalWatch = null;
    var waitingForTiers = null;
    var stackActive = false;
    var stackDeadline = 0;
    var stackTimer = 0;

    function queue() {
      if (!alive || frame) return;
      frame = window.requestAnimationFrame(update);
    }

    function stylesheetLoaded() {
      if (!alive) return;
      cssReady = true;
      bar.hidden = false;
      queue();
    }

    var link = document.getElementById('vob-css');
    if (!link && cssUrl) {
      link = document.createElement('link');
      link.id = 'vob-css';
      link.rel = 'stylesheet';
      link.href = cssUrl;
      link.addEventListener('load', stylesheetLoaded);
      document.head.appendChild(link);
    } else if (link) {
      if (link.sheet) stylesheetLoaded();
      else link.addEventListener('load', stylesheetLoaded);
    }

    function findBuy() {
      if (bundle) return root.querySelector('.vb-cta[data-cta]');
      // Stay inside this product section, excluding recommendation and drawer forms.
      return scope.querySelector('form[action*="/cart/add"] button[name="add"]');
    }

    function findFirstRow() {
      if (bundle) return root.querySelector('[data-tiers] .vb-tier[data-tier="1"]');
      var radio = root.querySelector('[data-stack-size][value="1"]');
      return radio && radio.closest('label');
    }

    function readContent() {
      if (bundle) {
        var single = root.querySelector('.vb-tier[data-tier="1"] .vb-now');
        var second = root.querySelector('.vb-tier[data-tier="2"] .vb-now');
        var selectedTwo = root.querySelector('.vb-tier[data-tier="2"].is-active');
        var total = selectedTwo && root.querySelector('[data-total]');
        return deriveBundle(single && single.textContent, second && second.textContent, total && total.textContent);
      }
      var configEl = root.querySelector('[data-stack-config]');
      var cfg = {};
      try { cfg = JSON.parse(configEl ? configEl.textContent : '{}'); } catch (error) { /* Use rendered text instead. */ }
      var form = buy && buy.closest('form');
      var id = form && form.querySelector('[name="id"]');
      var variant = (cfg.variants || []).find(function (item) { return String(item.id) === String(id ? id.value : cfg.initialVariant); });
      var singlePrice = root.querySelector('[data-stack-single-price]');
      var renderedPrice = parsePrice(singlePrice && singlePrice.textContent);
      var discount = cfg.discounts && cfg.discounts['2'];
      if (!Number.isFinite(discount)) {
        var row = root.querySelector('[data-stack-size][value="2"]');
        var label = row && row.closest('label');
        var match = label && label.textContent.match(/[−–-]\s*([\d.\s]+Ft)/);
        var renderedDiscount = match && parsePrice(match[1]);
        discount = renderedDiscount === null || !match ? null : renderedDiscount * 100;
      }
      return deriveStack(variant ? variant.price : (renderedPrice === null ? null : renderedPrice * 100), discount);
    }

    function isTextField(element) {
      return !!(element && (element.isContentEditable || element.matches('textarea, select, input:not([type]), ' +
        'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="search"], ' +
        'input[type="url"], input[type="password"], input[type="date"], input[type="datetime-local"], input[type="time"]')));
    }

    function modalOpen() {
      return Array.from(document.querySelectorAll('[aria-modal="true"]')).some(function (element) {
        // Closed <details> can leave its descendants with computed visibility: visible.
        if (element.closest('[hidden], [aria-hidden="true"], details:not([open])')) return false;
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
          style.opacity !== '0' && rect.width > 0 && rect.height > 0;
      });
    }

    function update() {
      frame = 0;
      if (!alive) return;
      if (!root.isConnected || root.hidden) { rescan(); return; }
      buy = findBuy();
      var content = readContent();
      // Read geometry first, then write text/classes; ResizeObserver measures the result.
      var rect = buy && buy.getBoundingClientRect();
      var firstRow = findFirstRow();
      var firstRowRect = firstRow && firstRow.getBoundingClientRect();
      if (cssReady) {
        var htmlStyle = window.getComputedStyle(document.documentElement);
        // Shrine's normal root is body-scale * 10 px (62.5% of 16 px).
        var normalRoot = 10 * (parseFloat(htmlStyle.getPropertyValue('--font-body-scale')) || 1);
        var largeText = parseFloat(htmlStyle.fontSize) > normalRoot + 0.1 ||
          parseFloat(window.getComputedStyle(priceEl).fontSize) > 16.1 ||
          parseFloat(window.getComputedStyle(offerEl).fontSize) > 12.1 ||
          parseFloat(window.getComputedStyle(button).fontSize) > 12.6;
        if (bar.classList.contains('vob--large-text') !== largeText) {
          bar.classList.toggle('vob--large-text', largeText);
          // Measure after lifting the clamp, before computing the hide boundary.
          height = 0;
        }
        if (!height) height = bar.getBoundingClientRect().height;
      }
      var legacy = document.getElementById('StickyATC');
      var now = window.performance.now();
      var active = !!document.querySelector(STACK_BLOCKERS);
      stackUsed = stackOfferUsed(stackUsed, active, [], document.documentElement);
      var delay = stackDelayRemaining(active, stackActive, stackDeadline, now);
      if (!active && stackActive) {
        stackDeadline = now + delay;
      }
      window.clearTimeout(stackTimer);
      if (!active && delay > 0) stackTimer = window.setTimeout(queue, delay);
      stackActive = active;
      var blocked = (!bundle && stackUsed) || delay > 0 || !!document.querySelector(BLOCKERS) || modalOpen() ||
        !!(legacy && !legacy.classList.contains('is-hidden')) || isTextField(document.activeElement);
      var visibility = { mobile: window.matchMedia('(max-width: 749px)').matches, ready: cssReady && !!content.price && height > 0,
        hasButton: !!(rect && rect.width && rect.height), buttonTop: rect && rect.top, firstRow: firstRowRect,
        viewportHeight: window.innerHeight, barHeight: height, blocked: blocked };
      var visible = shouldShow(visibility, offerNeeded);
      // Geometry memory is independent of temporary dialog/focus suppression.
      if (cssReady && height > 0) offerNeeded = offerNeedsBar(visibility, offerNeeded);
      if (priceEl.textContent !== content.price) priceEl.textContent = content.price;
      if (offerEl.textContent !== content.offer) offerEl.textContent = content.offer;
      // Suppression is immediate, so a closing slide cannot overlap another bar/modal.
      bar.classList.toggle('vob--blocked', blocked);
      if (visible && document.documentElement.style.getPropertyValue('--vob-height') !== height + 'px') {
        document.documentElement.style.setProperty('--vob-height', height + 'px');
      }
      if (visible !== shown) {
        shown = visible;
        bar.inert = !visible;
        button.tabIndex = visible ? 0 : -1;
        bar.setAttribute('aria-hidden', String(!visible));
        bar.classList.toggle('vob--visible', visible);
        document.documentElement.classList.toggle('vob-on', visible);
      }
      if (waitingForTiers && content.ready) { waitingForTiers.disconnect(); waitingForTiers = null; }
      watchTierNodes();
    }

    function watchTierNodes() {
      if (!bundle) return;
      var tiers = root.querySelector('[data-tiers]');
      var total = root.querySelector('[data-total]');
      if (tiers !== tierWatch) {
        tierObserver.disconnect();
        tierWatch = tiers;
        if (tiers) tierObserver.observe(tiers, { childList: true, characterData: true, subtree: true });
      }
      if (total !== totalWatch) {
        totalObserver.disconnect();
        totalWatch = total;
        if (total) totalObserver.observe(total, { childList: true, characterData: true, subtree: true });
      }
    }

    function headerBottom() {
      var pinned = new Set();
      var headers = [];
      document.querySelectorAll('.section-header, sticky-header, .announcement-bar, .v-announce-section, [data-v-announce], .shopify-section-group-header-group').forEach(function (element) {
        // Fixed/sticky positioning may be on the section wrapper rather than the header itself.
        var parent = element;
        while (parent && parent !== document.body) {
          var style = window.getComputedStyle(parent);
          if ((style.position === 'sticky' || style.position === 'fixed') && style.top !== 'auto') {
            if (!pinned.has(parent)) {
              pinned.add(parent);
              // Natural document offsets (such as the announcement above the header) scroll away.
              headers.push({ height: parent.getBoundingClientRect().height, top: parseFloat(style.top) || 0 });
            }
            break;
          }
          parent = parent.parentElement;
        }
      });
      return finalHeaderBottom(headers);
    }

    function navigate() {
      var target = scrollTarget(window.scrollY, root.getBoundingClientRect().top, headerBottom());
      window.scrollTo({ top: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    var tierObserver = new MutationObserver(queue);
    var totalObserver = new MutationObserver(queue);
    if (bundle && !readContent().ready) {
      waitingForTiers = new MutationObserver(queue);
      waitingForTiers.observe(root, { childList: true, characterData: true, subtree: true });
    }
    // Also catches cart/popup state changes, variant re-renders and replaced offer nodes.
    var observer = new MutationObserver(function (records) {
      // Capture even an activation removed before the next animation frame.
      stackUsed = stackOfferUsed(stackUsed, !!document.querySelector(STACK_BLOCKERS), records, document.documentElement);
      if (!bundle && stackUsed && shown) {
        window.cancelAnimationFrame(frame);
        update();
      }
      if (records.some(function (record) { return record.target !== bar && !bar.contains(record.target); })) queue();
    });
    observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true, attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal', 'data-vcb-open', 'value'] });
    var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
      if (entries.some(function (entry) { return entry.target === bar; })) height = bar.getBoundingClientRect().height;
      queue();
    }) : null;
    if (resizeObserver) { resizeObserver.observe(bar); resizeObserver.observe(scope === document ? root : scope); }
    function onResize() { height = 0; queue(); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onResize, { passive: true });
      window.visualViewport.addEventListener('scroll', queue, { passive: true });
    }
    ['focusin', 'focusout', 'change', 'input', 'variant:change', 'variant-change', 'product:variant-change', 'velora:stack-change'].forEach(function (name) { document.addEventListener(name, queue); });
    button.addEventListener('click', navigate);
    queue();

    return { root: root, queue: queue, destroy: function () {
      alive = false;
      window.cancelAnimationFrame(frame);
      window.clearTimeout(stackTimer);
      document.documentElement.classList.remove('vob-on');
      document.documentElement.style.removeProperty('--vob-height');
      observer.disconnect();
      tierObserver.disconnect();
      totalObserver.disconnect();
      if (waitingForTiers) waitingForTiers.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      if (link) link.removeEventListener('load', stylesheetLoaded);
      window.removeEventListener('scroll', queue);
      window.removeEventListener('resize', onResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', onResize);
        window.visualViewport.removeEventListener('scroll', queue);
      }
      ['focusin', 'focusout', 'change', 'input', 'variant:change', 'variant-change', 'product:variant-change', 'velora:stack-change'].forEach(function (name) { document.removeEventListener(name, queue); });
      bar.remove();
    } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
